import { debounce } from '@opten/reactive/debounce';
import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-contain-inner' })
export class ContainInnerComponent {
	private element: Element;
	private parent: Element;

	constructor(private wrapper: HTMLElement) {
		this.element = this.wrapper.children.item(0);
		this.parent = this.wrapper.parentElement;

		if (this.wrapper && this.element && this.parent) {
			this.calculate();

			window.addEventListener(
				'resize',
				debounce(() => this.calculate(), 300)
			);
			window.addEventListener(
				'orientationchange',
				debounce(() => this.calculate(), 300)
			);
		}
	}

	calculate() {
		const ratio = this.element.clientWidth / this.element.clientHeight;
		const parentRatio = this.parent.clientWidth / this.parent.clientHeight;

		let top = 0;
		let bottom = 0;
		let left = 0;
		let right = 0;

		if (parentRatio > ratio) {
			const height = this.parent.clientWidth / ratio;
			top = bottom = -1 * ((height - this.parent.clientHeight) / 2);
		} else if (parentRatio < ratio) {
			const width = this.parent.clientHeight * ratio;
			left = right = -1 * ((width - this.parent.clientWidth) / 2);
		}

		this.wrapper.style.top = top + 'px';
		this.wrapper.style.bottom = bottom + 'px';
		this.wrapper.style.left = left + 'px';
		this.wrapper.style.right = right + 'px';
	}
}
